import {
	Vue, Component, Watch, Prop, toNative,
} from 'vue-facing-decorator';
import * as DB from 'interfaces/database';
import { httpClient } from 'utils/http';
import { TabEvent } from 'interfaces/app';
import CustomSelect from 'components/CustomSelect';
import CustomCheckbox from 'components/CustomCheckbox';
import TemplatePosition from '../TemplatePosition';
import Template from './template.vue';

@Component({
	components: {
		TemplatePosition,
		CustomSelect,
		CustomCheckbox,
	},
	emits: ['routeTemplateState'],
	mixins: [Template],
})
class EditTemplateStateEdit extends Vue {
	private singleTemplateState = {} as DB.TemplatePositionStateModel;

	private loaded = false;

	private visible = false;

	private spinner = false;

	private index = 0;

	private isLoading = false;

	private options = ['photo', 'text'];

	@Prop({
		type: String,
		required: true,
	})
	public readonly templateStateId!: string;

	private get loggedIn(): boolean {
		return this.$auth0.isAuthenticated.value;
	}

	protected mounted(): void {
		this.getSingleTemplate();
	}

	protected get isPriorityNull(): boolean {
		return this.singleTemplateState.priority == null;
	}

	protected get isCombineTrue(): boolean {
		return this.singleTemplateState.combine === 1;
	}

	protected setPriorityToZero(): void {
		this.singleTemplateState.priority = 0;
	}

	protected onChangeEvent(event: number): void {
		this.singleTemplateState.combine = event;
	}

	@Watch('loggedIn')
	private async getSingleTemplate(): Promise<DB.TemplatePositionStateModel | undefined> {
		if (this.loggedIn) {
			// set the loading state
			this.isLoading = true;
			try {
				const resp = await httpClient.get<DB.TemplatePositionStateModel>(`/api/templatestate/${this.templateStateId}`);
				this.singleTemplateState = resp.data;
				// eslint-disable-next-line consistent-return
				return this.singleTemplateState;
			} catch (error: any) {
				this.$toastError(error.message);
			} finally {
				this.isLoading = false;
			}
		}
		return undefined;
	}

	protected async editTemplate(): Promise<DB.TemplatePositionStateModel | null> {
		if (this.loggedIn) {
			try {
				this.isLoading = true;
				const { data } = await httpClient.put<DB.TemplatePositionStateModel>(
					`/api/templatestate/${this.templateStateId}`,
					{ ...this.singleTemplateState },
				);
				this.$toastSuccess('Template edited successfully');
				return data;
			} catch (error: any) {
				this.$toastError(error.message);
			} finally {
				this.isLoading = false;
			}
		}
		return Promise.resolve(null);
	}

	protected routeTemplateState(data: TabEvent<DB.TemplatePositionStateModel>['editItem']): void {
		this.$emit(
			'routeTemplateState',
			{
				data,
			},
		);
	}
}

export default toNative(EditTemplateStateEdit);
